// jQuery(function (t) {
//   "use strict";
//   console.log("custom js...");
//   let e = 0, a = 0, n = 0, d = 0, i = 0, o = 0, s = 0, c = 0, l = false, h = false;
//   var r = 0;
//   function p() {
//     (r = t(".t4s-product-price").html()).includes("t4s-price-from") ? r = r.split("</span>")[1] : r.includes("</span></ins></span>") && (r = r.split("</span></ins></span>")[0].split('<ins><span class="money">')[1].split("</span>")[0]), r.includes("USD") && (r = r.split(" USD")[0]), r = Number(r.replace("$", "").trim()), console.log("Base product cost", r);
//   }
//   function u() {
//     (0 === r || function () {
//       let e = t(".t4s-product-price").html();
//       return e.includes("t4s-price-from") ? e = e.split("</span>")[1] : e.includes("</span></ins></span>") && (e = e.split("</span></ins></span>")[0].split('<ins><span class="money">')[1].split("</span>")[0]), e.includes("USD") && (e = e.split(" USD")[0]), e = Number(e.replace("$", "").trim()), e;
//     }() < r) && p(), setTimeout(() => {
//       const l = e + a + n + d + i + o + s + c + r;
//       t(".t4s-product-price").html("$" + l.toFixed(2) + " USD");
//     }, 1e3);
//   }
//   function f() {
//     e = 0, a = 0, n = 0, i = 0, o = 0, s = 0, c = 0, t("#add-patches-on-chest").val(t("#target option:first").val()), t(document).find(".left-chest-patch").addClass("hidden"), t(document).find(".right-chest-patch").addClass("hidden"), t(".left-chest-patch").find(".u4a-patch-value").text(""), t(".right-chest-patch").find(".u4a-patch-value").text(""), t(document).find(".left-chest-patch").find("input:radio").prop("checked", false), t(document).find(".right-chest-patch").find("input:radio").prop("checked", false), t("#add-patches-on-shoulders").val(t("#target option:first").val()), t(document).find(".left-shoulder-patch").addClass("hidden"), t(document).find(".right-shoulder-patch").addClass("hidden"), t(".left-shoulder-patch").find(".u4a-patch-value").text(""), t(".right-shoulder-patch").find(".u4a-patch-value").text(""), t(document).find(".left-shoulder-patch").find("input:radio").prop("checked", false), t(document).find(".right-shoulder-patch").find("input:radio").prop("checked", false);
//   }
//   t("#engrave-stock-badge").on("keyup", function (e) {
//     const a = t("#engrave-stock-badge").val();
//     console.log(a), a.length > 0 ? (l = true, c = 7.99, u()) : (l = false, c = 0, u());
//   }), t(document).on("change", "#add-patches-to-shirt", function (e) {
//     f(), "Yes" == t(this).val() ? (t(document).find(".patchesLevel1").removeClass("hidden"), t(document).find(".patchesLevel1").removeClass("hidden"), t(document).find("#tailoring-requires-additional-days").prop("checked", true)) : (t(document).find(".patchesLevel1").addClass("hidden"), t(document).find("#tailoring-requires-additional-days").prop("checked", false));
//   }), t(document).on("change", "#add-striping", function (e) {
//     f(), "Yes" == t(this).val() ? (c += 6.99, u(), t(".patchesLevel1.expedited-shipping").hide(), t(document).find(".patchesLevel2").removeClass("hidden"), t(document).find(".patchesLevel2").removeClass("hidden"), t(document).find("#striping-requires-additional-days").prop("checked", true)) : (c -= 6.99, u(), t(document).find(".patchesLevel2").addClass("hidden"), t(".patchesLevel1.expedited-shipping").show(), t(document).find("#striping-requires-additional-days").prop("checked", false));
//   }), t(document).on("change", "#add-patches-on-chest", function (d) {
//     const i = t(this).find(":selected").data("target");
//     e = t(this).find(":selected").data("amount"), t(document).find(".left-chest-patch").find("input:radio").prop("checked", false), t(document).find(".right-chest-patch").find("input:radio").prop("checked", false), t(".left-chest-patch").find(".u4a-patch-value").text(""), a = 0, t(".right-chest-patch").find(".u4a-patch-value").text(""), n = 0, "left-chest-patch" == i ? (t(document).find(".left-chest-patch").removeClass("hidden"), t(document).find(".right-chest-patch").addClass("hidden")) : "right-chest-patch" == i ? (t(document).find(".right-chest-patch").removeClass("hidden"), t(document).find(".left-chest-patch").addClass("hidden")) : "left-right-chest-patch" == i ? (t(document).find(".right-chest-patch").removeClass("hidden"), t(document).find(".left-chest-patch").removeClass("hidden")) : (t(document).find(".right-chest-patch").addClass("hidden"), t(document).find(".left-chest-patch").addClass("hidden"));
//   }), t(document).on("change", "#add-patches-on-shoulders", function (e) {
//     const a = t(this).find(":selected").data("target");
//     i = t(this).find(":selected").data("amount"), t(document).find(".left-shoulder-patch").find("input:radio").prop("checked", false), t(document).find(".right-shoulder-patch").find("input:radio").prop("checked", false), t(".left-shoulder-patch").find(".u4a-patch-value").text(""), t(".right-shoulder-patch").find(".u4a-patch-value").text(""), o = 0, s = 0, "left-shoulder-patch" == a ? (t(document).find(".left-shoulder-patch").removeClass("hidden"), t(document).find(".right-shoulder-patch").addClass("hidden")) : "right-shoulder-patch" == a ? (t(document).find(".right-shoulder-patch").removeClass("hidden"), t(document).find(".left-shoulder-patch").addClass("hidden")) : "left-right-shoulder-patch" == a ? (t(document).find(".right-shoulder-patch").removeClass("hidden"), t(document).find(".left-shoulder-patch").removeClass("hidden")) : (t(document).find(".right-shoulder-patch").addClass("hidden"), t(document).find(".left-shoulder-patch").addClass("hidden"));
//   }), t(document).on("change", "#add-patches-on-back", function (a) {
//     const n = t(this).find(":selected").data("target");
//     e = t(this).find(":selected").data("amount"), t(document).find(".back-patch").find("input:radio").prop("checked", false), t(".back-patch").find(".u4a-patch-value").text(""), d = 0, "back-patch" == n && t(document).find(".back-patch").removeClass("hidden");
//   }), t("#quantity").on("change", function () {
//     console.log("New quantity", t("#quantity").val()), setTimeout(() => u(), 1500);
//   }), t(document).on("click", ".t4s-quantity-selector", function () {
//     const e = t("#quantity").val();
//     e && (console.log("New product qty", e), setTimeout(() => u(), 1500));
//   }), t(document).on("change", "#select-hemming-length", function (e) {
//     t(this).find(":selected").data("target");
//     c = t(this).find(":selected").data("amount"), 0 != c ? (h = true, u()) : (h = false, u());
//   }), t(document).on("change", ".back-patch input[type=radio]", function (e) {
//     d = t(this).data("amount");
//     const a = parseFloat(t(this).data("amount")) ? " + $" + parseFloat(t(this).data("amount")) : "";
//     console.log(a), t(".back-patch").find(".u4a-patch-value").text("- " + t(this).val()), u();
//   }), t(document).on("change", ".left-chest-patch input[type=radio]", function (e) {
//     a = t(this).data("amount");
//     const n = parseFloat(t(this).data("amount")) ? " + $" + parseFloat(t(this).data("amount")) : "";
//     console.log(n), t(".left-chest-patch").find(".u4a-patch-value").text("- " + t(this).val()), u();
//   }), t(document).on("change", ".right-chest-patch input[type=radio]", function (e) {
//     n = t(this).data("amount");
//     const a = parseFloat(t(this).data("amount")) ? " + $" + parseFloat(t(this).data("amount")) : "";
//     console.log(a), t(".right-chest-patch").find(".u4a-patch-value").text("- " + t(this).val()), u();
//   }), t(document).on("change", ".left-shoulder-patch input[type=radio]", function (e) {
//     o = t(this).data("amount");
//     const a = parseFloat(t(this).data("amount")) ? " + $" + parseFloat(t(this).data("amount")) : "";
//     console.log(a), t(".left-shoulder-patch").find(".u4a-patch-value").text("- " + t(this).val()), u();
//   }), t(document).on("change", ".right-shoulder-patch input[type=radio]", function (e) {
//     s = t(this).data("amount");
//     const a = parseFloat(t(this).data("amount")) ? " + $" + parseFloat(t(this).data("amount")) : "";
//     console.log(a), t(".right-shoulder-patch").find(".u4a-patch-value").text("- " + t(this).val()), u();
//   }), t("button.t4s-product-form__submit").on("click", function (r) {
//     if (t("[data-swatch-option]").length !== t("[data-id]").find(".is--selected").length) return void r.preventDefault();
//     if (t(document).find(".variants-options").html(""), t(document).find("#u4aAdditionalPrice").val(""), "Yes" !== t("#add-patches-to-shirt").val() && false === l && false === h) return;
//     console.log("About to add products");
//     const p = t(this);
//     p.attr("aria-disabled", true), p.addClass("loading"), p.find(".loading-overlay__spinner").removeClass("hidden"), r.preventDefault(), console.log("Bada bing, bada boom"), c = l ? parseFloat("7.99") : h ? parseFloat("3.99") : parseFloat(e) + parseFloat(a) + parseFloat(n) + parseFloat(i) + parseFloat(o) + parseFloat(d) + parseFloat(s), c = c.toFixed(2), c > 0 ? t(document).find("#u4aAdditionalPrice").val("$" + c) : t(document).find("#u4aAdditionalPrice").val("");
//     const u = t(document).find(".u4a-variants-holder");
//     if (u.length) {
//       const e = u.children("fieldset");
//       t.each(e, function () {
//         const e = t(this).children("legend").children(".variantName").text(), a = t(document).find(`input[name=${e}]:checked`).val();
//         t(document).find(".variants-options").append(`<input type="hidden" name="properties[${e}]" value="${a}" />`);
//       });
//     }
//     if (!t(".t4s-form__product").validate().form()) return console.log("does not validate"), p.attr("aria-disabled", false), p.removeClass("loading"), void p.find(".loading-overlay__spinner").addClass("hidden");
//     console.log("validates");
//     let f = {}, m = "";
//     m = t(".t4s_ratio.t4s-product__media").find("img").length > 0 ? t("meta[property='og:image:secure_url']").attr("content") : t(".t4s-product__media-item.is--media-last").find("img").prop("currentSrc");
//     const g = new Image;
//     g.src = m;
//     var v = g.width, y = g.height;
//     console.log("Height", y, "Width", v), console.log(m), function (e, a, n) {
//       var d = t.Deferred(), i = new Konva.Stage({container: "custom-patches-image-container", width: a, height: n}), o = new Konva.Layer, s = new Image;
//       return s.onload = function () {
//         var e = new Konva.Image({x: 0, y: 0, image: s, width: a, height: n});
//         o.add(e), i.add(o);
//         var c = i.toDataURL();
//         console.log("dataURL", c), t("body").append(`<img src="${c}" id="img-src-base64" class="hidden" />`), d.resolve();
//       }, s.crossOrigin = "Anonymous", s.src = e, d.promise();
//     }(m, 0 === v ? 550 : v, 0 === y ? 550 : y).done(function () {
//       f.images = [{attachment: t(document).find("#img-src-base64").attr("src").replace(/^data:image\/(png|jpg);base64,/, "")}], f.title = t("meta[property='og:title']").attr("content"), f.sku = t(document).find(".t4s-sku-value").text(), f.parentURL = window.location.href.split("products")[1], f.price = 0 == c ? parseFloat(parseFloat(c) + parseFloat(t(".t4s-product-price").html().split("$")[1])).toFixed(2) : parseFloat(t(".t4s-product-price").html().split("$")[1]), console.log(f);
//       const e = function (e) {
//         let a = "";
//         return t.ajax({type: "POST", url: "https://stark-island-04924.herokuapp.com/api/products?store=686d7b-2", data: e, async: false, success: function (t) {
//           console.log(t), a = t.variants[0].id;
//         }}), a;
//       }(f);
//       if (console.log(e), undefined === e || !e) return p.attr("aria-disabled", false), p.removeClass("loading"), p.find(".loading-overlay__spinner").addClass("hidden"), void (alert("Something Went Wrong. Please Try Again") || window.location.reload());
//       let a, n;
//       for (a = t(".t4s-form__product").serializeArray(), n = 0; n < a.length; ++n) if ("id" == a[n].name) {
//         a[n].value = e;
//         break;
//       }
//       console.log(a), a = jQuery.param(a), console.log(a);
//       let d = false;
//       if (t.ajax({type: "POST", url: "/cart/add.js", dataType: "json", data: a, async: false, success: function (t) {
//         d = true;
//       }}), !d) return p.attr("aria-disabled", false), p.removeClass("loading"), p.find(".loading-overlay__spinner").addClass("hidden"), void (alert("Something Went Wrong. Please Try Again") || window.location.reload());
//       window.location.href = "/cart";
//     });
//   }), t(document).on("change", ".u4a-variants-holder fieldset input[type=radio]", function (e) {
//     t(this).parents("fieldset").children("legend").find(".selectedVariant").text(t(this).val());
//   });
// });


jQuery('.t4s-product-form__submit').click(() => {
    console.log('Add to cart clicked');

    jQuery('.t4s-form__product input').each(function(){
    if(!$(this).prop('required')){
        console.log("NR");
    } else {
        console.log("IR");
    }
  });
  
});


jQuery(function ($) {
  'use strict';
  console.log('custom js...');

  let chestPatchAmount = 0;
  let leftChestPatchAmount = 0;
  let rightChestPatchAmount = 0;
  let backPatchAmount = 0;
  let shoulderPatchAmount = 0;
  let leftShoulderPatchAmount = 0;
  let rightShoulderPatchAmount = 0;
  let totalExtraAmount = 0;
  let stockBadgeEngraving = false;
  let hemming = false;
  let striping = false;
  let customText = false;
  let wholesale = false;

  // const shopifyProductData = JSON.parse($('shopify-payment-terms').attr('shopify-meta'));

  let baseProductCost;
  const shopifyProductData = meta.product.variants;
  const currentSku = $('.t4s-productMeta__value.t4s-sku-value.t4s-csecondary').html();
  if (!currentSku) {
    baseProductCost = Number($('.t4s-product-price').html().split('$')[1].split(' USD')[0]);
  } else {
  
  const currentVariantID = shopifyProductData.find(i => i.sku === currentSku).id;
  console.log('Shopify Product Data', shopifyProductData);
  const currentProduct = shopifyProductData.find(i => i.id == currentVariantID);
  console.log('Current Product', currentProduct);
  
  baseProductCost = currentProduct.price / 100;
    console.log('Base product cost', baseProductCost)
  }
  if (baseProductCost > 5000) return;

  setTimeout(() => {
let wholesalePrice = $('table#wsaio-volume-discount--table tbody tr.wsaio_vdRow_40963218178118_1 td:nth-child(2)').text();
console.log('**', wholesalePrice);
  }, 2000);

let wholesalePrice = $('table#wsaio-volume-discount--table tbody tr.wsaio_vdRow_40963218178118_1 td:nth-child(2)').text();
console.log('**', wholesalePrice);
  if (wholesalePrice) {
    baseProductCost = Number($('table#wsaio-volume-discount--table tbody tr.wsaio_vdRow_40963218178118_1 td:nth-child(2)').text().split(' ')[0].replace('$', ''));
    console.log('Wholesale base product cost', baseProductCost);
    wholesale = true;
  }
  

const observer = new MutationObserver(function () {
    if (!wholesale) {
    const newSku = $('.t4s-sku-wrapper').children()[0].innerHTML;
    console.log('observed', newSku);
  const newProduct = shopifyProductData.find(i => i.sku == newSku);
   baseProductCost = newProduct.price / 100;
  console.log('New Base Product Cost', baseProductCost);
    }
    console.log('Base product cost in MutationObserver', baseProductCost);
  recalculatePrice();
});
  
observer.observe($('.t4s-sku-wrapper')[0], {
   attributes: true,        // Watch for attribute changes
    childList: true,        // Watch for child element changes
    subtree: true,          // Watch for changes in descendants
    characterData: true     // Watch for text content changes
});

  
  $('#engrave-stock-badge').on('keyup', function (e) {
    const val = $("#engrave-stock-badge").val();
    console.log(val);
    if (val.length > 0) {
      stockBadgeEngraving = true
      totalExtraAmount = 7.99;
      recalculatePrice();
    } else {
      stockBadgeEngraving = false
      totalExtraAmount = 0;
      recalculatePrice();
    }
  });


 $(document).on('change', '#consequetive-numbering-line-4', function (event) {

    if ($(this).val() == 'Yes') {
      $(document).find('.endingLine4').removeClass('hidden');

    } else {
      $(document).find('.endingLine4').addClass('hidden');
    }
  });

   $(document).on('change', '#consequetive-numbering-line-3', function (event) {

    if ($(this).val() == 'Yes') {
      $(document).find('.endingLine3').removeClass('hidden');

    } else {
      $(document).find('.endingLine3').addClass('hidden');
    }
  });

  
  $(document).on('change', '#add-text', function (event) {

    if ($(this).val().startsWith('Yes') || $(this).val().startsWith('Right')) {
      customText = true;
      totalExtraAmount += 9.99;
      recalculatePrice();
      $(document).find('.customTextLevel1').removeClass('hidden');

    } else {
            customText = false;
            totalExtraAmount -= 9.99;
      recalculatePrice();

      $(document).find('.customTextLevel1').addClass('hidden');
    }
  });

    $(document).on('change', '#print-sides', function (event) {
    if ($(this).val().includes('Front and Back')) totalExtraAmount += 5;
    else totalExtraAmount -= 5;
      recalculatePrice();
  });


$(document).on('change', '#add-velcro', function (event) {
      if ($(this).val() == 'Yes') {
        totalExtraAmount += 5;
      } else totalExtraAmount = 0;
      recalculatePrice();
  });
  
    $(document).on('change', '#add-removable-identifiers', function (event) {
      const amount = $("#add-removable-identifiers :selected").attr('data-amount');
      totalExtraAmount = Number(amount);
      recalculatePrice();

      const color = $('.is--selected').html();
      const size = $('.is-t4s-name__size .t4s-swatch__item.is--selected').html()

       if ($(this).val() == 'No') {
        $("#productColor").val('');
         $("#productSize").val('');
       } else if ($(this).val() == 'CUSTOM TEXT') {
          $(document).find('.customText').removeClass('hidden');
          if (color) $("#productColor").val(color);
         if (size) $("#productSize").val(size);
      } else {
          if (color) $("#productColor").val(color);
          if (size) $("#productSize").val(size);
          $(document).find('.customText').addClass('hidden');
      }
  });
  
  $(document).on('change', '#add-patches-to-shirt', function (event) {
    resetValues();

      const color = $('.is--selected').html();
    
    if ($(this).val() == 'Yes') {
      $(document).find('.patchesLevel1').removeClass('hidden');
       if (color) $("#productColor").val(color);

      $(document).find('.patchesLevel1').removeClass('hidden');

      
      $(document)
        .find('#tailoring-requires-additional-days')
        .prop('checked', true);
    } else {
      $(document).find('.patchesLevel1').addClass('hidden');
      $(document)
        .find('#tailoring-requires-additional-days')
        .prop('checked', false);
       $("#productColor").val('');
    }
  });

  $(document).on('change', '#add-patches-on-chest', function (event) {
    const target = $(this).find(':selected').data('target');
    chestPatchAmount = $(this).find(':selected').data('amount');

    $(document)
      .find('.left-chest-patch')
      .find('input:radio')
      .prop('checked', false);

    $(document)
      .find('.right-chest-patch')
      .find('input:radio')
      .prop('checked', false);

    $('.left-chest-patch').find('.u4a-patch-value').text('');
    leftChestPatchAmount = 0;
    $('.right-chest-patch').find('.u4a-patch-value').text('');
    rightChestPatchAmount = 0;

    if (target == 'left-chest-patch') {
      $(document).find('.left-chest-patch').removeClass('hidden');
      $(document).find('.right-chest-patch').addClass('hidden');
    } else if (target == 'right-chest-patch') {
      $(document).find('.right-chest-patch').removeClass('hidden');
      $(document).find('.left-chest-patch').addClass('hidden');
    } else if (target == 'left-right-chest-patch') {
      $(document).find('.right-chest-patch').removeClass('hidden');
      $(document).find('.left-chest-patch').removeClass('hidden');
    } else {
      $(document).find('.right-chest-patch').addClass('hidden');
      $(document).find('.left-chest-patch').addClass('hidden');
    }
  });

  $(document).on('change', '#add-patches-on-shoulders', function (event) {
    const target = $(this).find(':selected').data('target');
    shoulderPatchAmount = $(this).find(':selected').data('amount');

    $(document)
      .find('.left-shoulder-patch')
      .find('input:radio')
      .prop('checked', false);

    $(document)
      .find('.right-shoulder-patch')
      .find('input:radio')
      .prop('checked', false);

    $('.left-shoulder-patch').find('.u4a-patch-value').text('');
    $('.right-shoulder-patch').find('.u4a-patch-value').text('');
    leftShoulderPatchAmount = 0;
    rightShoulderPatchAmount = 0;

    if (target == 'left-shoulder-patch') {
      $(document).find('.left-shoulder-patch').removeClass('hidden');
      $(document).find('.right-shoulder-patch').addClass('hidden');
    } else if (target == 'right-shoulder-patch') {
      $(document).find('.right-shoulder-patch').removeClass('hidden');
      $(document).find('.left-shoulder-patch').addClass('hidden');
    } else if (target == 'left-right-shoulder-patch') {
      $(document).find('.right-shoulder-patch').removeClass('hidden');
      $(document).find('.left-shoulder-patch').removeClass('hidden');
    } else {
      $(document).find('.right-shoulder-patch').addClass('hidden');
      $(document).find('.left-shoulder-patch').addClass('hidden');
    }
  });
  
  $(document).on('change', '#add-patches-on-back', function (event) {
    const target = $(this).find(':selected').data('target');
    chestPatchAmount = $(this).find(':selected').data('amount');

    $(document)
      .find('.back-patch')
      .find('input:radio')
      .prop('checked', false);

    $('.back-patch').find('.u4a-patch-value').text('');
    backPatchAmount = 0;
    
    if (target == 'back-patch') {
      $(document).find('.back-patch').removeClass('hidden');
    }
  });

  function recalculatePrice() {

    let wholesaleBase;
    if (!wholesale) {
    wholesaleBase = $('.pro_des ins .money').first().text();
    console.log('sdfsfsd', wholesaleBase);
    if (wholesaleBase) { 
      wholesaleBase = Number(wholesaleBase.replace('$', '').trim());
    console.log(wholesaleBase);
      wholesale = wholesaleBase;
      baseProductCost = wholesale;
    }
    }

     let newPrice = chestPatchAmount + 
       leftChestPatchAmount + 
       rightChestPatchAmount + 
       backPatchAmount + 
       shoulderPatchAmount + 
       leftShoulderPatchAmount + 
       rightShoulderPatchAmount + 
       totalExtraAmount + baseProductCost;

       if (wholesaleBase) {
        newPrice = newPrice - baseProductCost + wholesaleBase;
       }
       console.log()
    console.log('Recalculation happening', newPrice, baseProductCost);
      $('.t4s-product-price').html('$' + newPrice.toFixed(2) + ' USD');
  }

  
$(document).on('change', '#add-hemming', function (event) {
    if ($(this).val() == 'Yes') {
      hemming = true;
      totalExtraAmount += 4.99;
      recalculatePrice();
      $('.patchesLevel1').removeClass('hidden');
    } else {
      hemming = false;
      totalExtraAmount -= 4.99;
      recalculatePrice();
      $('.patchesLevel1').addClass('hidden');
    }
  });

      $(document).on('change', '#add-striping', function (event) {

    if ($(this).val() == 'Yes') {
      striping = true;
      totalExtraAmount += 9.99;
      recalculatePrice();

      $(".patchesLevel1.expedited-shipping").hide();
      
      $(document).find('.patchesLevel2').removeClass('hidden');

      $(document).find('.patchesLevel2').removeClass('hidden');

      
      $(document)
        .find('#striping-requires-additional-days')
        .prop('checked', true);
    } else {
      striping = false;
      totalExtraAmount -= 9.99;
      recalculatePrice();

      
      $(document).find('.patchesLevel2').addClass('hidden');
       $(".patchesLevel1.expedited-shipping").show();
      $(document)
        .find('#striping-requires-additional-days')
        .prop('checked', false);
    }
  });
  

  $(document).on(
    'change',
    '.back-patch input[type=radio]',
    function (event) {
      backPatchAmount = $(this).data('amount');
      const amount = parseFloat($(this).data('amount'))
        ? ' + $' + parseFloat($(this).data('amount'))
        : '';
      console.log(amount);

      $('.back-patch')
        .find('.u4a-patch-value')
        .text('- ' + $(this).val());

     recalculatePrice();

    }
    
  );

  $(document).on(
    'change',
    '.left-chest-patch input[type=radio]',
    function (event) {
      leftChestPatchAmount = $(this).data('amount');
      const amount = parseFloat($(this).data('amount'))
        ? ' + $' + parseFloat($(this).data('amount'))
        : '';
      console.log(amount);

      $('.left-chest-patch')
        .find('.u4a-patch-value')
        .text('- ' + $(this).val());

      recalculatePrice();

      
    }
  );

  
  $(document).on(
    'change',
    '.right-chest-patch input[type=radio]',
    function (event) {
      rightChestPatchAmount = $(this).data('amount');
      const amount = parseFloat($(this).data('amount'))
        ? ' + $' + parseFloat($(this).data('amount'))
        : '';
      console.log(amount);

      $('.right-chest-patch')
        .find('.u4a-patch-value')
        .text('- ' + $(this).val());

      recalculatePrice();
    }
  );

  $(document).on(
    'change',
    '.left-shoulder-patch input[type=radio]',
    function (event) {
      leftShoulderPatchAmount = $(this).data('amount');
      const amount = parseFloat($(this).data('amount'))
        ? ' + $' + parseFloat($(this).data('amount'))
        : '';
      console.log(amount);

      $('.left-shoulder-patch')
        .find('.u4a-patch-value')
        .text('- ' + $(this).val());

      recalculatePrice();
      
    }
  );

  $(document).on(
    'change',
    '.right-shoulder-patch input[type=radio]',
    function (event) {
      rightShoulderPatchAmount = $(this).data('amount');
      const amount = parseFloat($(this).data('amount'))
        ? ' + $' + parseFloat($(this).data('amount'))
        : '';
      console.log(amount);

      $('.right-shoulder-patch')
        .find('.u4a-patch-value')
        .text('- ' + $(this).val());

        recalculatePrice();

    }
  );

/*$('button.t4s-product-form__submit').on('click', async function (event) {
    event.preventDefault(); // Prevent default action immediately
    const currButton = $(this);

    try {
        // Validate options first
        const hasOptions = $('[data-swatch-option]').length;
        const optionsSelected = $('[data-id]').find('.is--selected').length;
        if (hasOptions !== optionsSelected) return;

        // Clear elements
        $(document).find('.variants-options').html('');
        $(document).find('#u4aAdditionalPrice').val('');

        // Early return check
        if ($('#add-patches-to-shirt').val() !== 'Yes' & stockBadgeEngraving === false &&
            hemming === false && striping === false && customText === false && totalExtraAmount == 0) return;

        // UI Loading state
        currButton.attr('aria-disabled', true).addClass('loading');
        currButton.find('.loading-overlay__spinner').removeClass('hidden');

        // Price calculation
        if (stockBadgeEngraving) {
            totalExtraAmount = 7.99;
        } else if (hemming) {
            totalExtraAmount = 3.99;
        } else {
            totalExtraAmount = [
                chestPatchAmount,
                leftChestPatchAmount,
                rightChestPatchAmount,
                shoulderPatchAmount,
                leftShoulderPatchAmount,
                backPatchAmount,
                rightShoulderPatchAmount
            ].reduce((sum, val) => sum + parseFloat(val), 0);
        }

        // Update price display
        const displayPrice = totalExtraAmount > 0 ? `$${totalExtraAmount.toFixed(2)}` : '';
        $(document).find('#u4aAdditionalPrice').val(displayPrice);

        // Handle variants
        const variantsHolder = $(document).find('.u4a-variants-holder');
        if (variantsHolder.length) {
            variantsHolder.find('fieldset').each(function () {
                const variantName = $(this).find('.variantName').text();
                const variantValue = $(`input[name=${variantName}]:checked`).val();
                $(document).find('.variants-options').append(
                    `<input type="hidden" name="properties[${variantName}]" value="${variantValue}" />`
                );
            });
        }

        // Form validation
        if (!$('.t4s-form__product').validate().form()) {
            throw new Error('Form validation failed');
        }

        // Product creation logic
        const product = {
            title: $("meta[property='og:title']").attr('content'),
            sku: $(document).find('.t4s-sku-value').text(),
            parentURL: window.location.href.split('products')[1],
            price: parseFloat($('.t4s-product-price').html().split('$')[1]),
            id: meta.product.id
        };

        // Image handling
        const isVariant = $('.t4s_ratio.t4s-product__media').find('img').length > 0;
        const imgSrc = isVariant
            ? $("meta[property='og:image:secure_url']").attr('content')
            : $('.t4s-product__media-item.is--media-last').find('img').prop('currentSrc');

        // Convert image to base64
        const base64Result = await new Promise((resolve) => {
            getBase64Image(imgSrc, 550, 550).done(resolve);
        });

        product.images = [{
            attachment: base64Result.replace(/^data:image\/(png|jpg);base64,/, '')
        }];

        // File upload handling
        let fileUrl;
        if ($('#upload-file')[0]?.files?.length) {
            const formData = new FormData();
            formData.append('file', $('#upload-file')[0].files[0]);

            const response = await fetch('https://uaw-shopify-server.onrender.com/api/uploads/single', {
                method: 'POST',
                body: formData
            });
            const data = await response.json();
            fileUrl = data.fileUrl;
        }

        console.log('File URL:', fileUrl);


        // Add custom properties for the uploaded image
        const customProperties = {};
        if (fileUrl) {
            customProperties['Uploaded Image'] = fileUrl; // Add fileUrl as a custom property
        }
        // Create product variant
        const variantID = await createProduct(product);
        if (!variantID) throw new Error('Product creation failed');

        // Prepare cart data with custom properties
        const values = $('.t4s-form__product').serializeArray();

        // Add custom properties to the form data
        Object.entries(customProperties).forEach(([key, value]) => {
            values.push({
                name: `properties[${key}]`,
                value: value
            });
        });

        // Find and replace variant ID in form data
        values.some(item => {
            if (item.name === 'id') {
                item.value = variantID;
                return true;
            }
        });

        // Convert to URL-encoded string for AJAX call
        const cartData = jQuery.param(values);

        try {
            await $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: cartData
            });

            window.location.href = '/cart';

        } catch (error) {
            console.error('Cart add error:', error);
            throw new Error('Failed to add to cart');
        }

    } catch (error) {
        console.error('Error:', error);
        currButton.attr('aria-disabled', false)
                  .removeClass('loading')
                  .find('.loading-overlay__spinner')
                  .addClass('hidden');
        
        if (!alert('Something went wrong. Please try again')) {
            window.location.reload();
        }
    }
});*/
  
$('button.t4s-product-form__submit').on('click', function (event) {
const hasOptions = $('[data-swatch-option]').length;
const optionsSelected = $('[data-id]').find('.is--selected').length;
if (hasOptions !== optionsSelected) {
event.preventDefault();
return;
}

$(document).find('.variants-options').html('');
$(document).find('#u4aAdditionalPrice').val('');

if ($('#add-patches-to-shirt').val() !== 'Yes' && stockBadgeEngraving === false && hemming === false && striping === false && customText === false && totalExtraAmount == 0) return;

console.log('About to add products')

const currButton = $(this);
currButton.attr('aria-disabled', true);
currButton.addClass('loading');
currButton.find('.loading-overlay__spinner').removeClass('hidden');

event.preventDefault();

if (stockBadgeEngraving) {
totalExtraAmount = parseFloat('7.99');
} else if (hemming) {
totalExtraAmount = parseFloat('3.99');
} else {
totalExtraAmount =
parseFloat(chestPatchAmount) +
parseFloat(leftChestPatchAmount) +
parseFloat(rightChestPatchAmount) +
parseFloat(shoulderPatchAmount) +
parseFloat(leftShoulderPatchAmount) +
parseFloat(backPatchAmount) +
parseFloat(rightShoulderPatchAmount);
}

totalExtraAmount = totalExtraAmount.toFixed(2);

if (totalExtraAmount > 0) {
$(document)
.find('#u4aAdditionalPrice')
.val('$' + totalExtraAmount);
} else {
$(document).find('#u4aAdditionalPrice').val('');
}

const variantsHolder = $(document).find('.u4a-variants-holder');
if (variantsHolder.length) {
const fieldsets = variantsHolder.children('fieldset');
$.each(fieldsets, function () {
const variantName = $(this)
.children('legend')
.children('.variantName')
.text();
const variantValue = $(document)
.find(`input[name=${variantName}]:checked`)
.val();

$(document)
.find('.variants-options')
.append(
`<input type="hidden" name="properties[${variantName}]" value="${variantValue}" />`
);
});
}

if ($('.t4s-form__product').validate().form()) {
console.log('validates');
} else {
console.log('does not validate');
currButton.attr('aria-disabled', false);
currButton.removeClass('loading');
currButton.find('.loading-overlay__spinner').addClass('hidden');
return;
}

// Create New Product
let product = {};

// const imgSrc = $(document).find('#variantImgURL').val()
// ? decodeURIComponent(
// ($(document).find('#variantImgURL').val() + '').replace(/\+/g, '%20')
// )
// : $("meta[property='og:image:secure_url']").attr('content');

let imgSrc = '';

const isVariant = $('.t4s_ratio.t4s-product__media').find('img').length > 0;

if (isVariant) {
imgSrc = $("meta[property='og:image:secure_url']").attr('content');
} else imgSrc = $('.t4s-product__media-item.is--media-last').find('img').prop('currentSrc')
const image = new Image();
image.src = imgSrc;
var width = image.width;
var height = image.height;
console.log('Height', height, 'Width', width);
console.log(imgSrc);
getBase64Image(imgSrc, width === 0 ? 550 : width, height === 0 ? 550 : height).then(function () {
product.images = [
{
attachment: $(document)
.find('#img-src-base64')
.attr('src')
.replace(/^data:image\/(png|jpg);base64,/, ''),
},
];
product.title = $("meta[property='og:title']").attr('content');
product.sku = $(document).find('.t4s-sku-value').text();
product.parentURL = window.location.href.split('products')[1];
if (totalExtraAmount == 0) {
product.price = parseFloat(
parseFloat(totalExtraAmount) +
parseFloat($('.t4s-product-price').html().split('$')[1])
).toFixed(2);
} else {
product.price = parseFloat($('.t4s-product-price').html().split('$')[1]);
}

console.log(product);
product.id = meta.product.id;

let _file = false;
if ($("#upload-file") && $('#upload-file')[0] && $('#upload-file')[0].files.length > 0) {
    _file = $('#upload-file')[0].files[0];
}

if (_file) {
    const formData = new FormData();
    formData.append('file', _file);

      fetch('https://uaw-shopify-server.onrender.com/api/uploads/single', {
            method: 'POST',
            body: formData,
        }).then(response => response.json()).then(data => {
        
        console.log(data)

        const fileUrl = data.fileUrl;

const variantID = createProduct(product);
console.log(variantID);
if (typeof variantID === 'undefined' || !variantID) {
currButton.attr('aria-disabled', false);
currButton.removeClass('loading');
currButton.find('.loading-overlay__spinner').addClass('hidden');
if (!alert('Something Went Wrong. Please Try Again')) {
window.location.reload();
}
return;
}

let values, index;

// Get the parameters as an array
values = $('.t4s-form__product').serializeArray();
  console.log(values);

  if (fileUrl) {
    values.push({ name: 'properties[Image Upload]', value: fileUrl });
  }

        console.log(values);

// Find and replace `content` if there
for (index = 0; index < values.length; ++index) {
if (values[index].name == 'id') {
values[index].value = variantID;
break;
}
}

// Convert to URL-encoded string
values = jQuery.param(values);
console.log(values);

let success = false;

$.ajax({
type: 'POST',
url: '/cart/add.js',
dataType: 'json',
data: values,
async: false,
success: function (res) {
success = true;
},
});
if (!success) {
currButton.attr('aria-disabled', false);
currButton.removeClass('loading');
currButton.find('.loading-overlay__spinner').addClass('hidden');
if (!alert('Something Went Wrong. Please Try Again')) {
window.location.reload();
}
return;
}

window.location.href = '/cart';
return;
        
        
      });
} else {

const variantID = createProduct(product);
console.log(variantID);
if (typeof variantID === 'undefined' || !variantID) {
currButton.attr('aria-disabled', false);
currButton.removeClass('loading');
currButton.find('.loading-overlay__spinner').addClass('hidden');
if (!alert('Something Went Wrong. Please Try Again')) {
window.location.reload();
}
return;
}

let values, index;

// Get the parameters as an array
values = $('.t4s-form__product').serializeArray();
  console.log(values);

// Find and replace `content` if there
for (index = 0; index < values.length; ++index) {
if (values[index].name == 'id') {
values[index].value = variantID;
break;
}
}

// Convert to URL-encoded string
values = jQuery.param(values);
console.log(values);

let success = false;

$.ajax({
type: 'POST',
url: '/cart/add.js',
dataType: 'json',
data: values,
async: false,
success: function (res) {
success = true;
},
});
if (!success) {
currButton.attr('aria-disabled', false);
currButton.removeClass('loading');
currButton.find('.loading-overlay__spinner').addClass('hidden');
if (!alert('Something Went Wrong. Please Try Again')) {
window.location.reload();
}
return;
}

window.location.href = '/cart';
return;
}
});
});

function getBase64Image(imgSrc) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL('image/jpeg'));
        };
        img.onerror = (error) => reject(error);
        img.src = imgSrc;
    });
}
  

 $('button.t4s-sticky-atc__atc.t4s-btn-loading__svg').on('click', function (event) {
   console.log('farmer');
    const hasOptions = $('[data-swatch-option]').length;
    const optionsSelected = $('[data-id]').find('.is--selected').length;
    if (hasOptions !== optionsSelected) {
      event.preventDefault();
      return;
    }

    
    $(document).find('.variants-options').html('');
    $(document).find('#u4aAdditionalPrice').val('');
    
    if ($('#add-patches-to-shirt').val() !== 'Yes' & stockBadgeEngraving === false && hemming === false && striping === false && customText === false) return;
    
  console.log('About to add products')
    
    const currButton = $(this);
    currButton.attr('aria-disabled', true);
    currButton.addClass('loading');
    currButton.find('.loading-overlay__spinner').removeClass('hidden');
  
    event.preventDefault();
    console.log('Bada bing, bada boom');

    if (stockBadgeEngraving) { 
      totalExtraAmount = parseFloat('7.99');
  } else if (hemming) {
       totalExtraAmount = parseFloat('3.99');
      } else { 
      totalExtraAmount =
      parseFloat(chestPatchAmount) +
      parseFloat(leftChestPatchAmount) +
      parseFloat(rightChestPatchAmount) +
      parseFloat(shoulderPatchAmount) +
      parseFloat(leftShoulderPatchAmount) +
      parseFloat(backPatchAmount) +
      parseFloat(rightShoulderPatchAmount);
    }

    totalExtraAmount = totalExtraAmount.toFixed(2);

    if (totalExtraAmount > 0) {
      $(document)
        .find('#u4aAdditionalPrice')
        .val('$' + totalExtraAmount);
    } else {
      $(document).find('#u4aAdditionalPrice').val('');
    }

    const variantsHolder = $(document).find('.u4a-variants-holder');
    if (variantsHolder.length) {
      const fieldsets = variantsHolder.children('fieldset');
      $.each(fieldsets, function () {
        const variantName = $(this)
          .children('legend')
          .children('.variantName')
          .text();
        const variantValue = $(document)
          .find(`input[name=${variantName}]:checked`)
          .val();

        $(document)
          .find('.variants-options')
          .append(
            `<input type="hidden" name="properties[${variantName}]" value="${variantValue}" />`
          );
      });
    }

    if ($('.t4s-form__product').validate().form()) {
      console.log('validates');
    } else {
      console.log('does not validate');
      currButton.attr('aria-disabled', false);
      currButton.removeClass('loading');
      currButton.find('.loading-overlay__spinner').addClass('hidden');
      return;
    }

    // Create New Product
    let product = {};

    // const imgSrc = $(document).find('#variantImgURL').val()
    //   ? decodeURIComponent(
    //       ($(document).find('#variantImgURL').val() + '').replace(/\+/g, '%20')
    //     )
    //   : $("meta[property='og:image:secure_url']").attr('content');

  let imgSrc = '';

    const isVariant = $('.t4s_ratio.t4s-product__media').find('img').length > 0;

    if (isVariant) {
          imgSrc = $("meta[property='og:image:secure_url']").attr('content');
    } else imgSrc = $('.t4s-product__media-item.is--media-last').find('img').prop('currentSrc')
    const image = new Image();
    image.src = imgSrc;
    var width = image.width;
    var height = image.height;
    console.log('Height', height, 'Width', width);
    console.log(imgSrc);
    getBase64Image(imgSrc, width === 0 ? 550 : width, height === 0 ? 550 : height).done(function () {
      product.images = [
        {
          attachment: $(document)
            .find('#img-src-base64')
            .attr('src')
            .replace(/^data:image\/(png|jpg);base64,/, ''),
        },
      ];
      product.title = $("meta[property='og:title']").attr('content');
      product.sku = $(document).find('.t4s-sku-value').text();
      product.parentURL = window.location.href.split('products')[1];
      if (totalExtraAmount == 0) {
        product.price = parseFloat(
          parseFloat(totalExtraAmount) +
            parseFloat($('.t4s-product-price').html().split('$')[1])
        ).toFixed(2);
      } else {
        product.price = parseFloat($('.t4s-product-price').html().split('$')[1]);
      }

      console.log(product);

      const variantID = createProduct(product);
      console.log(variantID);
      if (typeof variantID === 'undefined' || !variantID) {
        currButton.attr('aria-disabled', false);
        currButton.removeClass('loading');
        currButton.find('.loading-overlay__spinner').addClass('hidden');
        if (!alert('Something Went Wrong. Please Try Again')) {
          window.location.reload();
        }
        return;
      }

      let values, index;

      // Get the parameters as an array
      values = $('.t4s-form__product').serializeArray();

      // Find and replace `content` if there
      for (index = 0; index < values.length; ++index) {
        if (values[index].name == 'id') {
          values[index].value = variantID;
          break;
        }
      }

      // Convert to URL-encoded string
      console.log(values);
      values = jQuery.param(values);
      console.log(values);

      let success = false;

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: values,
        async: false,
        success: function (res) {
          success = true;
        },
      });
      if (!success) {
        currButton.attr('aria-disabled', false);
        currButton.removeClass('loading');
        currButton.find('.loading-overlay__spinner').addClass('hidden');
        if (!alert('Something Went Wrong. Please Try Again')) {
          window.location.reload();
        }
        return;
      }

      window.location.href = '/cart';
      return;
    });
  });
  
  

  function getBase64Image(img, width, height) {
    var dfrd1 = $.Deferred();
    var stage = new Konva.Stage({
      container: 'custom-patches-image-container',
      width,
      height,
    });
    var layer = new Konva.Layer();
    var patchImage = new Image();
    patchImage.onload = function () {
      var yoda = new Konva.Image({
        x: 0,
        y: 0,
        image: patchImage,
        width,
        height,
      });

      layer.add(yoda);
      stage.add(layer);
      var dataURL = stage.toDataURL();
      console.log('dataURL', dataURL);
      $('body').append(
        `<img src="${dataURL}" id="img-src-base64" class="hidden" />`
      );
      dfrd1.resolve();
    };
    patchImage.crossOrigin = 'Anonymous';
    patchImage.src = img;

    return dfrd1.promise();
  }

  function resetValues() {
    chestPatchAmount = 0;
    leftChestPatchAmount = 0;
    rightChestPatchAmount = 0;
    shoulderPatchAmount = 0;
    leftShoulderPatchAmount = 0;
    rightShoulderPatchAmount = 0;
    totalExtraAmount = 0;

    $('#add-patches-on-chest').val($('#target option:first').val());
    $(document).find('.left-chest-patch').addClass('hidden');
    $(document).find('.right-chest-patch').addClass('hidden');
    $('.left-chest-patch').find('.u4a-patch-value').text('');
    $('.right-chest-patch').find('.u4a-patch-value').text('');
    $(document)
      .find('.left-chest-patch')
      .find('input:radio')
      .prop('checked', false);
    $(document)
      .find('.right-chest-patch')
      .find('input:radio')
      .prop('checked', false);

    $('#add-patches-on-shoulders').val($('#target option:first').val());
    $(document).find('.left-shoulder-patch').addClass('hidden');
    $(document).find('.right-shoulder-patch').addClass('hidden');
    $('.left-shoulder-patch').find('.u4a-patch-value').text('');
    $('.right-shoulder-patch').find('.u4a-patch-value').text('');
    $(document)
      .find('.left-shoulder-patch')
      .find('input:radio')
      .prop('checked', false);

    $(document)
      .find('.right-shoulder-patch')
      .find('input:radio')
      .prop('checked', false);
  }

  function createProduct(product) {
  let url = 'https://uaw-shopify-server.onrender.com/api/products?store=686d7b-2';
  const variants = meta.product.variants;
  const variant = variants.find(i => i.sku === product.sku);
  console.log('Variant', variant);
  if (variant) {
    let attr1 = '';
    let attr2 = '';
    const { public_title } = variant;
    if (public_title && public_title.includes(' / ')) {
      attr1 = public_title.split(' / ')[0];
      attr2 = public_title.split(' / ')[1];
    } else {
      attr1 = public_title;
    }

    url += `&attr1=${attr1}`;
    if (attr2) url += `&attr2=${attr2}`;
  }
    
    let variantID = '';
    $.ajax({
      type: 'POST',
      url,
      data: product,
      async: false,
      success: function (res) {
        console.log(res);
        variantID = res.variants[0].id;
      },
    });
    return variantID;
  }

  $(document).on(
    'change',
    '.u4a-variants-holder fieldset input[type=radio]',
    function (event) {
      $(this)
        .parents('fieldset')
        .children('legend')
        .find('.selectedVariant')
        .text($(this).val());
    }
  );
});